import { COGNITO_CLIENT_ID } from '@config/cognito';
import { getCognitoDomain } from '@domain/routes/urls';

export const getTokenUrl = (grantType: 'refresh_token' | 'authorization_code'): string =>
  `${getCognitoDomain()}/oauth2/token?client_id=${COGNITO_CLIENT_ID}&grant_type=${grantType}`;
